/* unplugin-vue-components disabled */import { render } from "./ExamNoticeModal.vue?vue&type=template&id=7b33104a&scoped=true&ts=true"
import script from "./ExamNoticeModal.vue?vue&type=script&lang=ts"
export * from "./ExamNoticeModal.vue?vue&type=script&lang=ts"

import "./ExamNoticeModal.vue?vue&type=style&index=0&id=7b33104a&lang=less&scoped=true"

import exportComponent from "/project/node_modules/.pnpm/vue-loader@16.7.0_@vue+compiler-sfc@3.2.23_vue@3.2.23_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b33104a"]])